import mixpanel from "mixpanel-browser";

const DEFAULT_MIXPANEL_TOKEN = "ff3e758ac7032068de518392fe0dc7ab";

let initialized = false;

export function initializeAnalytics(): boolean {
  if (initialized) return true;

  if (process.env.REACT_APP_MIXPANEL_ENABLED !== "true") return false;

  const token = process.env.REACT_APP_MIXPANEL_TOKEN || DEFAULT_MIXPANEL_TOKEN;
  const isDevelopment = process.env.NODE_ENV === "development";
  mixpanel.init(token, {
    debug: isDevelopment,
    ...(!isDevelopment && {
      api_host: typeof window === "undefined" ? "http://localhost" : window.location.origin,
      api_routes: { track: "api/events/collect/" },
    }),
  });
  initialized = true;
  return true;
}

export type AnalyticsProperties = Record<string, string | number | boolean>;

export function trackEvent(name: string, properties?: AnalyticsProperties): void {
  if (!initialized) return;
  mixpanel.track(name, properties);
}

export function analyticsPageForPath(pathname: string): string | null {
  if (pathname === "/" || pathname === "/news") return "News";
  if (pathname === "/vibes" || pathname.startsWith("/vibes/")) return "Vibes";
  if (pathname === "/historic_news" || pathname.startsWith("/historic_news/")) return "Stories";
  if (pathname === "/modquiz" || pathname.startsWith("/modquiz/")) return "Quiz";
  if (pathname === "/radio") return "Radio";
  if (pathname === "/classical" || pathname.startsWith("/classical/")) return "Classical";
  return null;
}
